module.exports = __webpack_public_path__ + "037cb6871d78539634da4ba9af16e295.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/leagues/europa.png
// module id = 1046
// module chunks = 0